// The supplier's generic price for a master product, read off the family
// price matrix (the non-paginated read model over supplier_prices). Quoting
// starts from this number in EVERY path — auto quotes inherit it server-side,
// and the manual paths (grid cell, workbench, similar variant) prefill it here
// — so the desk quotes the standing price unless it negotiates a new one.

import type { FamilyMatrixDeal } from 'apis/exclusive-deals';

// A supplier can hold more than one row for the same master product (an
// inactive/expired price alongside a live one). Preference: active first, then
// the most recently modified, then the highest id — the same "newest wins"
// rule the catalog's exclusiveDeals ordering uses.
export function findSupplierPrice(
  deals: FamilyMatrixDeal[] | undefined,
  masterProductId: number | undefined,
  supplierId: number | undefined
): FamilyMatrixDeal | undefined {
  if (!deals || masterProductId == null || supplierId == null) return undefined;
  const modifiedAt = (deal: FamilyMatrixDeal) =>
    deal.lastModifiedAt ? new Date(deal.lastModifiedAt).getTime() : 0;
  return deals
    .filter((deal) => deal.masterProductId === masterProductId && deal.supplierId === supplierId)
    .sort(
      (a, b) => Number(b.isActive) - Number(a.isActive) || modifiedAt(b) - modifiedAt(a) || b.id - a.id
    )[0];
}
